module.exports = __webpack_public_path__ + "img/signal_cellular_4_bar-green.42ecd1ee.svg";